import { create } from 'zustand';

import { AuthStoreState } from '@/shared/store/auth.store';
import { ProfileStoreState } from '@/shared/store/profile.store';

type AuthFlowStoreStoreState = Pick<
  AuthStoreState,
  'legacyToken' | 'accessToken' | 'account' | 'schemaVersion'
> & {
  profile: Partial<ProfileStoreState> | null;
  pin: string | null;
};

type AuthFlowStoreStore = AuthFlowStoreStoreState & {
  setAccessToken: (authTokens: AuthStoreState['accessToken']) => void;
  setLegacyToken: (legacyToken: AuthStoreState['legacyToken']) => void;
  setAccount: (account: AuthStoreState['account']) => void;
  setSchemaVersion: (schemaVersion: number) => void;
  setProfileData: (profile: Partial<ProfileStoreState>) => void;
  setPin: (pin: string | null) => void;
  clear: () => void;
};

const getInitialState = (): AuthFlowStoreStoreState => ({
  accessToken: null,
  legacyToken: null,
  account: null,
  schemaVersion: null,
  profile: null,
  pin: null,
});

export const useAuthFlowStore = create<AuthFlowStoreStore>((set, get) => ({
  ...getInitialState(),

  setAccessToken: (accessToken) => set({ accessToken }),
  setLegacyToken: (legacyToken) => set({ legacyToken }),
  setAccount: (account) => set({ account }),
  setSchemaVersion: (schemaVersion) => set({ schemaVersion }),
  setPin: (pin) => set({ pin }),

  setProfileData: (profile) =>
    set({
      profile: {
        ...get().profile,
        ...profile,
      },
    }),
  clear: () => set({ ...getInitialState() }),
}));
